// extracted by mini-css-extract-plugin
export var currentStep = "_is-2";
export var nodeCard = "_is-0";
export var pathHighlighted = "_is-1";